module.exports = __webpack_public_path__ + "static/media/tour-wireframe.c401871e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/tour-wireframe.jpg
// module id = 302
// module chunks = 0